import { selfHostedComputersPath } from "@p0security/shared/integrations/resources/self-hosted/constants";
import { SelfHostedComputer } from "@p0security/shared/integrations/resources/self-hosted/types";
import { where } from "firebase/firestore";

import { useFirestoreCollection } from "../../../../providers/FirestoreProvider.tsx";

export const useSelfHostedComputers = ({
  tenantId,
  environmentId,
}: {
  tenantId: string;
  environmentId: string;
}) => {
  return useFirestoreCollection<SelfHostedComputer>(
    selfHostedComputersPath(tenantId),
    {
      live: true,
      queryConstraints: [where("environmentId", "==", environmentId)],
    }
  );
};
